const Button = ({
  className,
  children,
  onClick,
  disabled,
  type,
}: ButtonInterface) => {
  if (!type) type = 'button'
  return (
    <>
      <button
        disabled={disabled}
        onClick={onClick}
        type={type}
        className={` px-5 text-sm bg-primary
        flex justify-center items-center  border rounded-md  ${className} ${
          disabled ? 'opacity-50' : ''
        }`}
      >
        {children}
      </button>
    </>
  )
}

export default Button
